import { render } from "./PosPreviewReceipt.vue?vue&type=template&id=fa25ee22&scoped=true&ts=true"
import script from "./PosPreviewReceipt.vue?vue&type=script&lang=ts"
export * from "./PosPreviewReceipt.vue?vue&type=script&lang=ts"

import "./PosPreviewReceipt.vue?vue&type=style&index=0&id=fa25ee22&scoped=true&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa25ee22"]])

export default __exports__